import { deliveryInfo, deliveryTag } from './pricing';
// Donnees des machines pour les pages "location {machine} + {ville}" premium.
// Finistere Sud + Morbihan max Lorient — donnees pour pages machines de gourmandises.

const atCity = (c) => (c === 'Bretagne' ? 'en Bretagne' : `à ${c}`);

export const MACHINES = {
  'barbe-a-papa': {
    slug: 'barbe-a-papa',
    keyword: 'barbe à papa',
    keywordFull: 'machine à barbe à papa',
    displayName: 'Barbe à Papa',
    icon: 'Candy',
    primaryColor: 'from-pink-100 to-rose-100',
    accentColor: 'text-pink-600',
    borderColor: 'border-pink-300',
    price: '60 €',
    priceLabel: '60 € TTC / jour',
    packPrice: '120 €',
    packName: 'Pack Mariage',
    capacity: '~200 barbes à papa',
    consumables: 'Kit sucre coloré + bâtons + sachets',
    included: [
      'Machine barbe à papa pro (chariot vintage)',
      '1 kg de sucre coloré (rose/blanc/bleu)',
      '100 bâtons en bois',
      '100 sachets kraft',
      'Livraison + installation',
      'Démonstration + nettoyage',
    ],
    packIncluded: [
      'Machine barbe à papa pro',
      '3 kg de sucre coloré (3 couleurs)',
      '300 bâtons + 300 sachets',
      'Décoration vintage optionnelle',
      'Livraison + installation',
      'Démonstration',
    ],
    heroIntro: (city) => `Vous cherchez à louer une machine à barbe à papa ${atCity(city)} pour un mariage, un anniversaire, une kermesse ou votre entreprise ?`,
    productDesc: (city) => `Machine à barbe à papa professionnelle (chariot vintage) ${atCity(city)}. Kit sucre coloré + bâtons + sachets inclus. Livraison, installation et démonstration.`,
    faqs: (city) => [
      {
        q: `Combien coûte la location d'une machine à barbe à papa ${atCity(city)} ?`,
        a: `Nos tarifs sont publics : 60 € TTC / jour (machine seule + kit 200 barbes à papa) ou 120 € TTC pour le Pack Mariage (~600 barbes à papa, 3 couleurs de sucre, décoration incluse). Livraison en supplément selon distance ${atCity(city)}.`,
      },
      {
        q: `Combien de barbes à papa la machine peut-elle produire ?`,
        a: `Notre machine professionnelle produit environ 60 barbes à papa par heure, soit 200 sur une journée (formule standard) ou 600 sur un week-end (Pack Mariage). Le sucre coloré offre 3 saveurs : rose framboise, blanc vanille, bleu barbe à papa.`,
      },
      {
        q: `La machine est-elle simple à utiliser ${atCity(city)} ?`,
        a: `Oui ! Nous vous montrons son fonctionnement à la livraison ${atCity(city)} (5 min de démo). Un enfant de 10 ans peut faire des barbes à papa sans problème. Idéal pour animer un anniversaire ou une kermesse.`,
      },
      {
        q: `Puis-je réserver longtemps à l'avance ?`,
        a: `Absolument. Nous acceptons les réservations jusqu'à 12 mois à l'avance. Les samedis d'été et les fêtes de fin d'année sont très demandés — un acompte de 30 % bloque votre date ${atCity(city)}.`,
      },
    ],
    localEventsFallback: (city) => [
      { title: `Anniversaires enfants ${atCity(city)}`, desc: 'La star des goûters : les enfants adorent voir la machine fonctionner en direct.' },
      { title: `Kermesses & fêtes d'école`, desc: `Écoles et associations de ${city} nous louent chaque année pour animer leurs stands gourmands.` },
      { title: `Mariages & vins d'honneur`, desc: `La barbe à papa vintage crée un effet nostalgie qui plaît autant aux adultes qu'aux enfants.` },
    ],
    seoDescCommon: 'Location machine barbe à papa professionnelle. Chariot vintage. Kit sucre + bâtons inclus. 4,9★ 50+ avis. Devis 24h.',
  },
  'pop-corn': {
    slug: 'pop-corn',
    keyword: 'pop-corn',
    keywordFull: 'machine à pop-corn',
    displayName: 'Pop-Corn',
    icon: 'Popcorn',
    primaryColor: 'from-amber-100 to-yellow-100',
    accentColor: 'text-amber-600',
    borderColor: 'border-amber-300',
    price: '90 €',
    priceLabel: '90 € TTC / jour',
    packPrice: '160 €',
    packName: 'Pack Événement',
    capacity: '~100 portions',
    consumables: 'Maïs premium + huile + sachets kraft',
    included: [
      'Machine pop-corn style cinéma (vitrine chauffante)',
      'Maïs premium (500 g)',
      'Huile spéciale',
      '100 sachets kraft',
      'Livraison + installation',
      'Démonstration + nettoyage',
    ],
    packIncluded: [
      'Machine pop-corn style cinéma pro',
      'Maïs premium (2 kg, ~300 portions)',
      'Huile spéciale + sel',
      '300 sachets kraft',
      'Vitrine chauffante décorée',
      'Livraison + démonstration',
    ],
    heroIntro: (city) => `Envie de louer une machine à pop-corn style cinéma ${atCity(city)} pour un anniversaire, un mariage, une soirée ou un événement d'entreprise ?`,
    productDesc: (city) => `Machine à pop-corn professionnelle style cinéma (vitrine chauffante) ${atCity(city)}. Maïs premium + huile + sachets kraft inclus.`,
    faqs: (city) => [
      {
        q: `Combien coûte la location d'une machine à pop-corn ${atCity(city)} ?`,
        a: `Tarifs publics : 90 € TTC / jour (machine + kit ~100 portions) ou 160 € TTC pour le Pack Événement (~300 portions, vitrine décorée). Livraison selon distance ${atCity(city)}.`,
      },
      {
        q: `Combien de pop-corn la machine produit-elle ?`,
        a: `Notre machine style cinéma produit environ 100 portions sur la formule standard et jusqu'à 300 sur un événement. Rendu identique aux cinémas : croustillant, salé, chaud.`,
      },
      {
        q: `Peut-on louer la machine avec un stand décoré ${atCity(city)} ?`,
        a: `Oui ! Le Pack Événement inclut une vitrine chauffante décorée façon cinéma vintage. Effet nostalgie garanti pour vos invités ${atCity(city)}.`,
      },
      {
        q: `Est-ce compatible avec un anniversaire enfant ?`,
        a: `Parfait ! Nos anniversaires ${atCity(city)} intègrent souvent la machine à pop-corn en option. Les enfants adorent le bruit de l'éclatement du maïs — c'est une animation en soi.`,
      },
    ],
    localEventsFallback: (city) => [
      { title: `Soirées entre amis ${atCity(city)}`, desc: 'Effet cinéma garanti : le pop-corn frais crée une ambiance immédiate.' },
      { title: `Anniversaires enfants`, desc: `L'animation gourmande préférée des enfants ${atCity(city)} — bruit + odeur + goût.` },
      { title: `Événements d'entreprise / CSE`, desc: `Comité d'entreprise, arbre de Noël, séminaire : le pop-corn se transforme en pause détente.` },
    ],
    seoDescCommon: 'Location machine pop-corn style cinéma. Vitrine chauffante. Maïs premium + huile + sachets kraft. 4,9★ 50+ avis.',
  },
  'granite': {
    slug: 'granite',
    keyword: 'granité',
    keywordFull: 'machine à granité',
    displayName: 'Granité',
    icon: 'CupSoda',
    primaryColor: 'from-cyan-100 to-blue-100',
    accentColor: 'text-cyan-600',
    borderColor: 'border-cyan-300',
    price: '140 €',
    priceLabel: '140 € TTC / jour',
    packPrice: '190 €',
    packName: 'Pack Événement',
    capacity: '~100 granités',
    consumables: '2 sirops au choix + pailles + gobelets',
    included: [
      'Machine à granité double bac (2 parfums)',
      '2 sirops au choix (fraise, citron, cola, framboise bleue, pomme verte, orange, coco, cassis, barbe à papa, passion)',
      '100 pailles + 100 gobelets',
      'Livraison + installation',
      'Démonstration + nettoyage',
    ],
    packIncluded: [
      'Machine à granité double bac pro',
      '4 sirops au choix (~250 granités)',
      '250 pailles + 250 gobelets',
      'Bar granité décoré',
      'Livraison + installation',
      'Démonstration',
    ],
    heroIntro: (city) => `Louez une machine à granité (slush) double bac professionnelle ${atCity(city)} pour rafraîchir vos invités mariage, anniversaire ou événement.`,
    productDesc: (city) => `Machine à granité (slush) professionnelle double bac (2 parfums) ${atCity(city)}. Sirops + pailles + gobelets inclus. Idéal mariage estival, kermesse, événement plage.`,
    faqs: (city) => [
      {
        q: `Combien coûte la location d'une machine à granité ${atCity(city)} ?`,
        a: `Nos tarifs publics : 140 € TTC / jour (machine double bac + kit ~100 granités, 2 sirops au choix) ou 190 € TTC pour le Pack Événement (~250 granités, 4 sirops, bar décoré). Vous savez ce que vous payez, sans mauvaise surprise.`,
      },
      {
        q: `Quels parfums de sirop puis-je choisir ${atCity(city)} ?`,
        a: `10 saveurs disponibles : fraise, citron, cola, framboise bleue, pomme verte, orange, barbe à papa, coco, cassis, fruit de la passion. Vous choisissez 2 parfums (formule standard) ou 4 parfums (Pack Événement).`,
      },
      {
        q: `Combien de granités la machine produit-elle ?`,
        a: `Notre machine double bac professionnelle produit environ 100 granités par bac (200 au total en formule standard) ou 250 sur un Pack Événement. Idéal pour un mariage estival ${atCity(city)}, une kermesse ou un événement plage.`,
      },
      {
        q: `Qu'est-ce qui rend votre offre unique ${atCity(city)} ?`,
        a: `Trois avantages : 1) Nos prix sont publics et transparents. 2) Nous sommes basés à Quimper — proximité et réactivité pour ${city}. 3) Nous proposons une prestation combinée (machine + animation clown-magicien-mascotte) — un combo unique en Bretagne.`,
      },
    ],
    localEventsFallback: (city) => [
      { title: `Mariages estivaux ${atCity(city)}`, desc: 'La star des vins d\'honneur : glaces italiennes et granités frais font sensation par forte chaleur.' },
      { title: `Événements plage / bord de mer`, desc: `Rafraîchir vos invités avec un vrai granité coloré et savoureux ${atCity(city)}.` },
      { title: `Kermesses & festivals`, desc: `Écoles, associations, festivals estivaux : le granité est un classique attendu ${atCity(city)}.` },
    ],
    seoDescCommon: 'Location machine granité (slush) professionnelle double bac. 2 parfums + pailles + gobelets. 10 saveurs. 4,9★.',
  },
};

// Villes ciblees : Finistere Sud + Morbihan max Lorient (comme demande par l'utilisateur)
export const MACHINE_CITIES = {
  quimper: { name: 'Quimper', slug: 'quimper', dept: 'Finistère', code: '29', geoRegion: 'FR-29', distanceQuimper: '0 km (base)', deliveryInfo: deliveryInfo(0), deliveryTag: deliveryTag(0), zones: ['Centre-ville', 'Locmaria', 'Kerfeunteun', 'Ergué-Armel', 'Penhars', 'Pluguffan', 'Ergué-Gabéric'], distanceKm: 0 },
  concarneau: { name: 'Concarneau', slug: 'concarneau', dept: 'Finistère', code: '29', geoRegion: 'FR-29', distanceQuimper: '25 km depuis Quimper', deliveryInfo: deliveryInfo(25), deliveryTag: deliveryTag(25), zones: ['Centre Concarneau', 'Ville Close', 'Rosporden', 'Trégunc', 'Pont-Aven', 'Melgven'], distanceKm: 25 },
  fouesnant: { name: 'Fouesnant', slug: 'fouesnant', dept: 'Finistère', code: '29', geoRegion: 'FR-29', distanceQuimper: '18 km depuis Quimper', deliveryInfo: deliveryInfo(18), deliveryTag: deliveryTag(18), zones: ['Fouesnant centre', 'Beg-Meil', 'Mousterlin', 'La Forêt-Fouesnant', 'Pleuven', 'Saint-Évarzec'], distanceKm: 18 },
  benodet: { name: 'Bénodet', slug: 'benodet', dept: 'Finistère', code: '29', geoRegion: 'FR-29', distanceQuimper: '15 km depuis Quimper', deliveryInfo: deliveryInfo(15), deliveryTag: deliveryTag(15), zones: ['Bénodet centre', 'Sainte-Marine', 'Combrit', 'Le Perguet', 'Clohars-Fouesnant'], distanceKm: 15 },
  'pont-l-abbe': { name: 'Pont-l\'Abbé', slug: 'pont-l-abbe', dept: 'Finistère', code: '29', geoRegion: 'FR-29', distanceQuimper: '17 km depuis Quimper', deliveryInfo: deliveryInfo(17), deliveryTag: deliveryTag(17), zones: ['Pont-l\'Abbé centre', 'Loctudy', 'Plobannalec', 'Île-Tudy', 'Combrit', 'Tréméoc'], distanceKm: 17 },
  douarnenez: { name: 'Douarnenez', slug: 'douarnenez', dept: 'Finistère', code: '29', geoRegion: 'FR-29', distanceQuimper: '22 km depuis Quimper', deliveryInfo: deliveryInfo(22), deliveryTag: deliveryTag(22), zones: ['Douarnenez centre', 'Tréboul', 'Poullan-sur-Mer', 'Pouldergat', 'Kerlaz', 'Cap Sizun'], distanceKm: 22 },
  quimperle: { name: 'Quimperlé', slug: 'quimperle', dept: 'Finistère', code: '29', geoRegion: 'FR-29', distanceQuimper: '45 km depuis Quimper', deliveryInfo: deliveryInfo(45), deliveryTag: deliveryTag(45), zones: ['Quimperlé centre', 'Riec-sur-Belon', 'Moëlan-sur-Mer', 'Clohars-Carnoët', 'Le Pouldu', 'Scaër'], distanceKm: 45 },
  brest: { name: 'Brest', slug: 'brest', dept: 'Finistère', code: '29', geoRegion: 'FR-29', distanceQuimper: '75 km depuis Quimper', deliveryInfo: deliveryInfo(75), deliveryTag: deliveryTag(75), zones: ['Brest centre', 'Saint-Marc', 'Lambézellec', 'Bellevue', 'Guipavas', 'Plougastel-Daoulas', 'Landerneau', 'Le Relecq-Kerhuon'], distanceKm: 75 },
  vannes: { name: 'Vannes', slug: 'vannes', dept: 'Morbihan', code: '56', geoRegion: 'FR-56', distanceQuimper: '115 km depuis Quimper', deliveryInfo: deliveryInfo(115), deliveryTag: deliveryTag(115), zones: ['Vannes centre', 'Séné', 'Arradon', 'Sarzeau', 'Auray (proche)', 'Île-aux-Moines', 'Baden', 'Larmor-Baden'], distanceKm: 115 },
  lorient: { name: 'Lorient', slug: 'lorient', dept: 'Morbihan', code: '56', geoRegion: 'FR-56', distanceQuimper: '70 km depuis Quimper', deliveryInfo: deliveryInfo(70), deliveryTag: deliveryTag(70), zones: ['Centre-ville Lorient', 'Lanester', 'Hennebont', 'Ploemeur', 'Guidel', 'Larmor-Plage', 'Quéven', 'Caudan'], distanceKm: 70 },
  // Page pilier régionale : /location-<machine> (sans ville) — regroupe tout le catalogue
  morlaix: { name: 'Morlaix', slug: 'morlaix', dept: 'Finistère', code: '29', geoRegion: 'FR-29', distanceQuimper: '80 km depuis Quimper', deliveryInfo: deliveryInfo(80), deliveryTag: deliveryTag(80), zones: ['Morlaix centre', 'Saint-Martin-des-Champs', 'Plourin-lès-Morlaix', 'Plouigneau', 'Carantec', 'Saint-Pol-de-Léon', 'Roscoff', 'Landivisiau'], distanceKm: 80, machines: ['barbe-a-papa', 'pop-corn', 'glace-italienne'] },
  landerneau: { name: 'Landerneau', slug: 'landerneau', dept: 'Finistère', code: '29', geoRegion: 'FR-29', distanceQuimper: '65 km depuis Quimper', deliveryInfo: deliveryInfo(65), deliveryTag: deliveryTag(65), zones: ['Landerneau centre', 'Plouédern', 'La Roche-Maurice', 'Pencran', 'Dirinon', 'Daoulas', 'Ploudaniel', 'La Forest-Landerneau'], distanceKm: 65, machines: ['barbe-a-papa', 'pop-corn'] },
  chateaulin: { name: 'Châteaulin', slug: 'chateaulin', dept: 'Finistère', code: '29', geoRegion: 'FR-29', distanceQuimper: '30 km depuis Quimper', deliveryInfo: deliveryInfo(30), deliveryTag: deliveryTag(30), zones: ['Châteaulin centre', 'Port-Launay', 'Pleyben', 'Cast', 'Plomodiern', 'Dinéault', 'Saint-Ségal', 'Le Faou'], distanceKm: 30, machines: ['barbe-a-papa', 'pop-corn', 'glace-italienne'] },
  carhaix: { name: 'Carhaix', slug: 'carhaix', dept: 'Finistère', code: '29', geoRegion: 'FR-29', distanceQuimper: '60 km depuis Quimper', deliveryInfo: deliveryInfo(60), deliveryTag: deliveryTag(60), zones: ['Carhaix-Plouguer centre', 'Plounévézel', 'Kergloff', 'Poullaouen', 'Spézet', 'Châteauneuf-du-Faou', 'Huelgoat', 'Motreff'], distanceKm: 60, machines: ['barbe-a-papa', 'pop-corn'] },
  bretagne: { name: 'Bretagne', slug: '', dept: 'Finistère / Morbihan', code: '29-56', geoRegion: 'FR-BRE', distanceQuimper: 'Livraison Bretagne (base Quimper)', deliveryInfo: '30 km gratuits autour de Quimper, puis 0,70 €/km', deliveryTag: '30 km offerts', zones: ['Finistère Sud (29)', 'Morbihan (56)', 'Quimper', 'Brest', 'Concarneau', 'Lorient', 'Vannes', 'Douarnenez'], distanceKm: 0, isPillar: true },
};
